import React, { useState } from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Grid from "@material-ui/core/Grid";
import { RoundedButton } from "@packages/ui";
import { Typography } from "@material-ui/core";
import * as virActions from "src/actions/virActions";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as appActions from "../../actions/appActions";
import VirComfirmDialog from "../VirConfirmDialog/VirConfirmDialog";
import getBrandFromUrl from "src/utils/getBrandFromUrl";

const VirLogoutBar = () => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const brand = getBrandFromUrl().toLowerCase();

  const handleOpen = () => {
    setOpen(true);
  };

  const logout = () => {
    dispatch(virActions.virLogout());
    dispatch(
      appActions.createToast({
        type: "success",
        message: "Logout success",
      })
    );
    navigate(`/vehicleincidents/landing-page?brand=${brand}`);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <AppBar
        position="fixed" // Fix the navigation bar to the top
        color="transparent"
        style={{ zIndex: 100 }}
        elevation={0}
      >
        <Toolbar>
          <Grid
            justifyContent="space-between" // Add it here :)
            container
            spacing={8}
          >
            <Grid item>
              <Typography type="title" color="inherit"></Typography>
            </Grid>

            <Grid item>
              <div>
                <RoundedButton onClick={handleOpen}>Logout</RoundedButton>
              </div>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <VirComfirmDialog
        open={open}
        handleClose={handleClose}
        execute={logout}
        content={"Are you sure you want to log out? Any unsaved changes will be lost."}
      />
    </>
  );
};

export default VirLogoutBar;
